import axios from "axios";
import { httpGet, httpPost } from "./index";
import {writeCookie} from "../utils";

export const login = async (data) => {
    let csrfCookie = await axios.get('/sanctum/csrf-cookie');
    if (csrfCookie) {
        let response = await httpPost('/v1/auth/login', data);
        if (response) {
            writeCookie('bearer_token', response.data.token, 30);
        }
    }
}

export const logout = async () => {
    await httpGet('/v1/auth/logout');
}

export const register = async (data) => {
    let csrfCookie = await axios.get('/sanctum/csrf-cookie');
    if (!csrfCookie) {
        return;
    }

    let response = await httpPost('/v1/auth/studio-register', data);
    if (response) {
        writeCookie('bearer_token', response.data.token, 30);
    }
}

export const resend = async (data) => {
  await httpPost('v1/auth/resend', data)
}
